module.exports = __webpack_public_path__ + "media/amp_version/pinterest-aebb8800.svg";